import React from "react";

import DispensaryMenuItemCardMobileSkeleton from "@/components/DispensaryMenuItemCard/DispensaryMenuItemCardMobileSkeleton";

export const MenuItemLoadingSkeleton = ({
  items = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
  ],
}: {
  items?: Array<string>;
}) => (
  <>
    {items.map((n: string) => (
      <DispensaryMenuItemCardMobileSkeleton key={n} />
    ))}
  </>
);

export default MenuItemLoadingSkeleton;
